import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../../login/login.component';
import { OdmAuthGuardGuard } from '../../odm-auth.guard.guard';

const routes: Routes = [{ path: 'login', canActivate: [OdmAuthGuardGuard], component: LoginComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
